import React from 'react';
import cn from 'classnames';

import Icon from 'components/generic/Icon.component';
import Space from 'components/generic/Space.component';
import CurrencySign from 'components/price/CurrencySign.component';
import TooltipForReceptionist from 'components/TooltipForReceptionist';
import IN from 'constants/in';
import { useTranslation } from 'providers/GILT.provider';
import C from 'utils/values/constant.util';

import CN from './PickerSmsButton.module.scss';

const TEXT_MESSAGES = C({
  fifty: 'fifty',
  fiveHundreds: 'five_hundreds',
  twoThousands: 'two_thousands',
});

const NormalPurchase = (props) => {
  const { t } = useTranslation();
  const { checked, label, smsCost, text, showTip, name } = props;

  return (
    <>
      <div
        data-bem="NormalPurchase"
        className={cn({
          [CN.purchaseBtn]: true,
          [CN.selected]: checked,
        })}
      >
        {props.showDiscountLabel && (
          <div className={CN.rotate}>
            <div className={CN.discountLabel}>
              <span className={CN.percent}>{props.discount}</span>{' '}
              {t('composite.purchaseSmsCreditDialog.discountLabel')}
            </div>
          </div>
        )}
        {label}
        <input type="radio" id={props.id} value={name} name={name} checked={checked} onChange={props.onChange} />
      </div>
      {showTip && name !== TEXT_MESSAGES.fifty && <TooltipForReceptionist where={IN.mainMenu} />}
      <div className={CN.planCost}>
        {t('composite.purchaseSmsCreditDialog.cost')} <CurrencySign value={smsCost} />
        <small className={CN.small}>{t('composite.purchaseSmsCreditDialog.tax')}</small>
      </div>
      <div className={CN.planText}>
        {t('composite.purchaseSmsCreditDialog.bookingsPart1')}
        <Space>
          <CurrencySign value={text} />
        </Space>
        {t('composite.purchaseSmsCreditDialog.bookingsPart2')}
      </div>
    </>
  );
};

const LowCreditWarning = (props) => {
  const { t } = useTranslation();
  const { checked, label, smsCost, showTip, name } = props;
  return (
    <>
      <div
        data-bem="LowCreditWarning"
        className={cn({
          [CN.lowCreditButton]: true,
          [CN.selected]: checked,
        })}
      >
        <Icon variant="radioCheck" selected={checked} width="lg" />
        <div className={CN.lowCredContent}>
          {label}
          <div className={CN.planCost}>
            <CurrencySign value={smsCost} />
            <span className={CN.vatText}>{t('composite.purchaseSmsCreditDialog.tax')}</span>
          </div>
        </div>
      </div>
      {showTip && name !== TEXT_MESSAGES.fifty && <TooltipForReceptionist where={IN.mainMenu} />}
    </>
  );
};

const PickerSmsButton = (props) => {
  const { variant, disabled, onClick } = props;

  const VariantComponent = variant === 'lowCredit' ? LowCreditWarning : NormalPurchase;

  return (
    <div
      data-bem="PickerSmsButton"
      className={cn({
        [CN.component]: true,
        [CN.disabled]: disabled,
        [CN[`${variant}Variant`]]: variant,
      })}
      role="button"
      tabIndex="-1"
      onClick={onClick}
    >
      <div className={CN.relative}>
        <VariantComponent {...props} />
      </div>
    </div>
  );
};

export default PickerSmsButton;
